// src\services\PlaylistMasterDataService.js
import http from '../http-common';

class PlaylistMasterDataService {
  getAll(id) {
    return http.get(`/get-users-playlist/${id}?_t=${Date.now()}`);
  }
}

export default new PlaylistMasterDataService();
